import { render, staticRenderFns } from "./SwifterStruct.vue?vue&type=template&id=af84d936&scoped=true"
import script from "./SwifterStruct.vue?vue&type=script&lang=js"
export * from "./SwifterStruct.vue?vue&type=script&lang=js"
import style0 from "./SwifterStruct.vue?vue&type=style&index=0&id=af84d936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af84d936",
  null
  
)

export default component.exports